import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioDropdown = _resolveComponent("StudioDropdown")!

  return (_ctx.workspaceSelectItems?.length)
    ? (_openBlock(), _createBlock(_component_StudioDropdown, {
        key: 0,
        selectedItemIndex: _ctx.selectedWorkspaceIndex,
        menuItems: _ctx.workspaceSelectItems,
        variant: _ctx.dropdownVariant,
        onSelect: _ctx.handleSelectWorkspaceFilter
      }, null, 8, ["selectedItemIndex", "menuItems", "variant", "onSelect"]))
    : _createCommentVNode("", true)
}